var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27735_107048)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0047 10.4348C28.7441 4.34206 22.8794 0 15.9999 0C9.12049 0 3.2558 4.34206 0.995117 10.4348H31.0047Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995117 21.5654C3.2558 27.6582 9.12049 32.0002 15.9999 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 -16H48V16.475H-16V-16Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 15.5249H48V47.9999H-16V15.5249Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5875 2.52519C33.2374 7.93769 19.9625 34.4752 3.67495 23.4252L2.57495 25.1252C12.1625 31.9502 21.65 26.4502 24.325 19.3252C27.1 11.9752 23.375 1.6377 12.75 0.575195L12.5875 2.52519Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2501 25.35L7.9626 26.6125L6.6876 29.3375L3.9751 28.0625L5.2501 25.35ZM23.8751 12.9125H26.8751V15.9125H23.8751V12.9125ZM22.4126 8.05L25.2001 6.975L26.2876 9.7625L23.5001 10.85L22.4126 8.05ZM19.1626 4.4125L21.3001 2.3L23.4126 4.425L21.2876 6.5375L19.1626 4.4125ZM15.8876 -0.5625L18.6876 0.487499L17.6251 3.2875L14.8251 2.2375L15.8876 -0.5625ZM23.5001 17.75L26.2876 18.8625L25.1626 21.6375L22.3876 20.525L23.5001 17.75ZM14.7626 26.5L17.5126 25.3375L18.7001 28.0875L15.9501 29.2625L14.7626 26.5ZM9.8251 26.85H12.8251V29.85H9.8251V26.85ZM14.9876 12.35L12.4501 10.475L9.9126 12.3L10.9126 9.425L8.3751 7.55H11.4376L12.5001 4.725L13.4751 7.5625L16.5626 7.525L14.1126 9.4375L14.9876 12.35Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0001 27.2998C25.8501 27.3498 25.2251 28.8498 24.7876 29.5748L25.2501 29.6998C26.9501 30.2998 27.8001 30.8498 28.5251 31.8873C28.694 32.0484 28.9139 32.1453 29.1468 32.1613C29.3797 32.1773 29.6108 32.1113 29.8001 31.9748C29.8001 31.9748 30.1501 31.8498 30.6001 31.3498C30.9751 30.7873 30.8751 30.3498 30.4251 29.9623C29.0501 28.9623 27.5626 28.2123 26.0001 27.2998Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6624 30.6002C29.6624 30.7444 29.6051 30.8827 29.5031 30.9847C29.4012 31.0867 29.2629 31.1439 29.1187 31.1439C28.9744 31.1439 28.8361 31.0867 28.7342 30.9847C28.6322 30.8827 28.5749 30.7444 28.5749 30.6002C28.5749 30.4576 28.6315 30.3209 28.7323 30.2201C28.8331 30.1193 28.9698 30.0627 29.1124 30.0627C29.255 30.0627 29.3917 30.1193 29.4925 30.2201C29.5933 30.3209 29.6499 30.4576 29.6499 30.6002H29.6624ZM26.9874 28.9002C26.9874 29.0444 26.9301 29.1827 26.8281 29.2847C26.7262 29.3867 26.5879 29.4439 26.4436 29.4439C26.2994 29.4439 26.1611 29.3867 26.0592 29.2847C25.9572 29.1827 25.8999 29.0444 25.8999 28.9002C25.8999 28.756 25.9572 28.6177 26.0592 28.5157C26.1611 28.4137 26.2994 28.3564 26.4436 28.3564C26.5879 28.3564 26.7262 28.4137 26.8281 28.5157C26.9301 28.6177 26.9874 28.756 26.9874 28.9002ZM28.3499 29.7752C28.3499 29.9194 28.2926 30.0577 28.1906 30.1597C28.0887 30.2617 27.9504 30.3189 27.8062 30.3189C27.6619 30.3189 27.5236 30.2617 27.4217 30.1597C27.3197 30.0577 27.2624 29.9194 27.2624 29.7752C27.2624 29.631 27.3197 29.4927 27.4217 29.3907C27.5236 29.2887 27.6619 29.2314 27.8062 29.2314C27.9504 29.2314 28.0887 29.2887 28.1906 29.3907C28.2926 29.4927 28.3499 29.631 28.3499 29.7752Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5625 29.4623C19.2375 26.4248 13.65 23.1498 8.31247 20.1123C5.97497 18.6498 5.86247 15.9373 7.43747 13.8748C7.58747 13.5873 7.78747 13.6498 7.86247 13.8123C8.04997 14.8123 8.61247 15.8498 9.28747 16.4998C14.8276 19.9848 20.3157 23.5518 25.75 27.1998C25.325 27.9248 25 28.7373 24.5625 29.4498V29.4623Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1499 22.1875L23.3749 24.1875L21.3749 26.4125L19.1499 24.4125L21.1499 22.1875Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 27.6001L9.8125 18.1626M23.5125 25.4251L18.25 22.0126M20.525 27.3501L15.1625 24.2501",
    stroke: "black",
    strokeWidth: 0.375
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 -16H48V48H-16V-16Z",
    fill: "#00CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 8H48V24H-16V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 10.5874H48V21.3749H-16V10.5874Z",
    fill: "#000001"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0047 10.4348C28.7441 4.34206 22.8794 0 15.9999 0C9.12049 0 3.2558 4.34206 0.995117 10.4348H31.0047Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995117 21.5654C3.2558 27.6582 9.12049 32.0002 15.9999 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 -16H48V16.475H-16V-16Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 15.5249H48V47.9999H-16V15.5249Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5875 2.52519C33.2374 7.93769 19.9625 34.4752 3.67495 23.4252L2.57495 25.1252C12.1625 31.9502 21.65 26.4502 24.325 19.3252C27.1 11.9752 23.375 1.6377 12.75 0.575195L12.5875 2.52519Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2501 25.35L7.9626 26.6125L6.6876 29.3375L3.9751 28.0625L5.2501 25.35ZM23.8751 12.9125H26.8751V15.9125H23.8751V12.9125ZM22.4126 8.05L25.2001 6.975L26.2876 9.7625L23.5001 10.85L22.4126 8.05ZM19.1626 4.4125L21.3001 2.3L23.4126 4.425L21.2876 6.5375L19.1626 4.4125ZM15.8876 -0.5625L18.6876 0.487499L17.6251 3.2875L14.8251 2.2375L15.8876 -0.5625ZM23.5001 17.75L26.2876 18.8625L25.1626 21.6375L22.3876 20.525L23.5001 17.75ZM14.7626 26.5L17.5126 25.3375L18.7001 28.0875L15.9501 29.2625L14.7626 26.5ZM9.8251 26.85H12.8251V29.85H9.8251V26.85ZM14.9876 12.35L12.4501 10.475L9.9126 12.3L10.9126 9.425L8.3751 7.55H11.4376L12.5001 4.725L13.4751 7.5625L16.5626 7.525L14.1126 9.4375L14.9876 12.35Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0001 27.2998C25.8501 27.3498 25.2251 28.8498 24.7876 29.5748L25.2501 29.6998C26.9501 30.2998 27.8001 30.8498 28.5251 31.8873C28.694 32.0484 28.9139 32.1453 29.1468 32.1613C29.3797 32.1773 29.6108 32.1113 29.8001 31.9748C29.8001 31.9748 30.1501 31.8498 30.6001 31.3498C30.9751 30.7873 30.8751 30.3498 30.4251 29.9623C29.0501 28.9623 27.5626 28.2123 26.0001 27.2998Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6624 30.6002C29.6624 30.7444 29.6051 30.8827 29.5031 30.9847C29.4012 31.0867 29.2629 31.1439 29.1187 31.1439C28.9744 31.1439 28.8361 31.0867 28.7342 30.9847C28.6322 30.8827 28.5749 30.7444 28.5749 30.6002C28.5749 30.4576 28.6315 30.3209 28.7323 30.2201C28.8331 30.1193 28.9698 30.0627 29.1124 30.0627C29.255 30.0627 29.3917 30.1193 29.4925 30.2201C29.5933 30.3209 29.6499 30.4576 29.6499 30.6002H29.6624ZM26.9874 28.9002C26.9874 29.0444 26.9301 29.1827 26.8281 29.2847C26.7262 29.3867 26.5879 29.4439 26.4436 29.4439C26.2994 29.4439 26.1611 29.3867 26.0592 29.2847C25.9572 29.1827 25.8999 29.0444 25.8999 28.9002C25.8999 28.756 25.9572 28.6177 26.0592 28.5157C26.1611 28.4137 26.2994 28.3564 26.4436 28.3564C26.5879 28.3564 26.7262 28.4137 26.8281 28.5157C26.9301 28.6177 26.9874 28.756 26.9874 28.9002ZM28.3499 29.7752C28.3499 29.9194 28.2926 30.0577 28.1906 30.1597C28.0887 30.2617 27.9504 30.3189 27.8062 30.3189C27.6619 30.3189 27.5236 30.2617 27.4217 30.1597C27.3197 30.0577 27.2624 29.9194 27.2624 29.7752C27.2624 29.631 27.3197 29.4927 27.4217 29.3907C27.5236 29.2887 27.6619 29.2314 27.8062 29.2314C27.9504 29.2314 28.0887 29.2887 28.1906 29.3907C28.2926 29.4927 28.3499 29.631 28.3499 29.7752Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5625 29.4623C19.2375 26.4248 13.65 23.1498 8.31247 20.1123C5.97497 18.6498 5.86247 15.9373 7.43747 13.8748C7.58747 13.5873 7.78747 13.6498 7.86247 13.8123C8.04997 14.8123 8.61247 15.8498 9.28747 16.4998C14.8276 19.9848 20.3157 23.5518 25.75 27.1998C25.325 27.9248 25 28.7373 24.5625 29.4498V29.4623Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1499 22.1875L23.3749 24.1875L21.3749 26.4125L19.1499 24.4125L21.1499 22.1875Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 27.6001L9.8125 18.1626M23.5125 25.4251L18.25 22.0126M20.525 27.3501L15.1625 24.2501",
    stroke: "black",
    strokeWidth: 0.375
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 -16H48V48H-16V-16Z",
    fill: "#00CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 8H48V24H-16V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 10.5874H48V21.3749H-16V10.5874Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 -16H48V48H16V-16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 -16H16V48H-16V-16Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 8.00001C28.1139 4.94974 25.3955 2.5658 22.1415 1.21793C18.8875 -0.129934 15.2796 -0.366407 11.8775 0.545192C8.47532 1.45679 5.46905 3.46551 3.3249 6.25982C1.18075 9.05413 0.0185547 12.4779 0.0185547 16C0.0185547 19.5222 1.18075 22.9459 3.3249 25.7402C5.46905 28.5345 8.47532 30.5432 11.8775 31.4548C15.2796 32.3664 18.8875 32.1299 22.1415 30.7821C25.3955 29.4342 28.1139 27.0503 29.875 24C28.2175 26.0702 25.958 27.5744 23.4086 28.3049C20.8593 29.0353 18.146 28.9559 15.6437 28.0776C13.1415 27.1993 10.9738 25.5655 9.44021 23.402C7.90666 21.2384 7.08297 18.6519 7.08297 16C7.08297 13.3481 7.90666 10.7616 9.44021 8.59806C10.9738 6.43451 13.1415 4.80069 15.6437 3.92239C18.146 3.04409 20.8593 2.96469 23.4086 3.69514C25.958 4.42559 28.2175 5.92984 29.875 8.00001ZM30.4 16L16 11.3L24.9625 23.575V8.425L16 20.7L30.4 16Z",
    fill: "#D21034"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_27735_107048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-16 -16H48V48H-16V-16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6645 -4H33V36H21.6645V-4ZM-1 -4H10.3355V36H-1V-4Z",
    fill: "#008753"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    width: 30.0096,
    height: 32,
    rx: 15.0048,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    width: 30.0096,
    height: 32,
    rx: 15.0048,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_27735_107048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-16 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.dfb0804a5b4ae1c2dbade8d5d3fe1562.svg";
export { ForwardRef as ReactComponent };